module.exports = __webpack_public_path__ + "static/media/web p1.cd7b3290.png";